import type { BridgeChartBar, NormalizedIndicatorSeries } from "../types/data";
import type { ChartLayout } from "../renderers/layout";

export interface PriceScale {
  min: number;
  max: number;
  ticks: number[];
  y(value: number): number;
}

export function buildPriceScale(
  bars: BridgeChartBar[],
  indicators: NormalizedIndicatorSeries[],
  start: number,
  end: number,
  layout: ChartLayout
): PriceScale {
  let min = Infinity;
  let max = -Infinity;
  const visibleDates = new Set(bars.map(bar => bar.date));
  bars.forEach(bar => {
    min = Math.min(min, bar.low);
    max = Math.max(max, bar.high);
  });
  indicators.filter(series => series.kind === "Overlay" && series.available).forEach(series => {
    series.points.forEach(point => {
      if (!visibleDates.has(point.date)) return;
      min = Math.min(min, point.value);
      max = Math.max(max, point.value);
    });
  });
  if (!Number.isFinite(min) || !Number.isFinite(max) || min === max) {
    min = min === Infinity ? 0 : min - 1;
    max = max === -Infinity ? 1 : max + 1;
  }
  const padding = (max - min) * 0.08;
  min -= padding;
  max += padding;
  return {
    min,
    max,
    ticks: makeTicks(min, max, 5),
    y(value: number) {
      return layout.top + (max - value) / (max - min) * layout.plotHeight;
    }
  };
}

export function makeTicks(min: number, max: number, count: number): number[] {
  const ticks: number[] = [];
  const step = (max - min) / Math.max(1, count - 1);
  for (let i = 0; i < count; i++) ticks.push(min + step * i);
  return ticks;
}
